import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface TopActiveUsersResponse {
  items: Array<Items>;
};

export interface Items {
  user_global_id: string; 
  user_id: string;
  user_sub_id: string;
  email: string;
  active_days: number;
  total_generation: number;
  yesterday_generation: number;
  today_generation: number;
  user_name: string;
};

export class TopActiveUsersItemsData {
  @Required("User id cannot be empty")
  @IsString("User id must be a string")
  userId: string;

  @Required("User sub id cannot be empty")
  @IsString("User sub id must be a string")
  userSubId: string;

  @Required("User global id cannot be empty")
  @IsString("User global id must be a string")
  userGlobalId: string;

  @Required("Email cannot be empty")
  @IsString("Email must be a string")
  email: string;

  @Required("User name cannot be empty")
  @IsString("User name must be a string")
  userName: string;

  @Required("Active days cannot be empty")
  @IsNumber("Active days must be a number")
  activeDays: number;

  @Required("Total generation cannot be empty")
  @IsNumber("Total generation must be a number")
  totalGeneration: number;

  @IsNumber("Yesterday generation must be a number")
  yesterdayGeneration: number;

  @Required("Today generation cannot be empty")
  @IsNumber("Today generation must be a number")
  todayGeneration: number;
}

export class TopActiveUsersData {
  @Required("items cannot be empty")
  @IsArray("items must be an array")
  items: TopActiveUsersItemsData[];
}

const transformAndValidateAgent = (
  response: TopActiveUsersResponse
): TopActiveUsersData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, TopActiveUsersData);
  } catch (error) {
    console.error("Agent User Top Active Users data validation failed:", error.message);
    throw error;
  }
};

/** 内容管理 - 活跃用户TOP10 */
export const topActiveUsers = async ({
  recentDays,
  limit,
  agentId,
}: {
  recentDays: number,
  limit: number,
  agentId: string,
}): Promise<TopActiveUsersData> => {
  const response = await api.post<TopActiveUsersResponse>('/agent-v2/user-stats/top-active', {
    recent_days: recentDays,
    limit,
    agent_id: agentId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
